export const transformAlignsToObject = (aligns: string[]) => {
  let index = 0;
  return aligns.reduce((accumulator, value) => {
    const newAccumulator: any = { ...accumulator, [index]: { halign: value } };
    index += 1;
    return newAccumulator;
  }, {});
};

type TCellData = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export const drawBottomLine = (doc: any, cellData: TCellData, color: string) => {
  const { x, y, width, height } = cellData;
  doc.setDrawColor(color);
  doc.setLineWidth(0.2);
  doc.line(x, y + height, x + width, y + height);
};
